import React from 'react'
import { Modal } from 'antd'
import {
  formatMetaValue,
  getVoiceMetaItems,
  getVoiceDescription
} from '../utils'

const VoiceDetailsModal = ({ voice, variant, displayName, visible, onClose }) => {
  if (!voice) return null

  const metaItems = getVoiceMetaItems(voice)
  const originalName = formatMetaValue(voice.name)
  const description = getVoiceDescription(voice, variant)
  const sourceLabel =
    variant === 'recommended'
      ? 'Recommended'
      : variant === 'custom'
      ? 'Custom Upload'
      : 'System Library'

  return (
    <Modal
      maskClosable={false}
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={520}
      centered
      className="voice-selection-modal__details-modal"
      title={displayName}
    >
      <div className="voice-selection-modal__details-source">{sourceLabel}</div>

      <div className="voice-selection-modal__details-list">
        <div className="voice-selection-modal__details-row">
          <span className="voice-selection-modal__details-key">Original name</span>
          <span className="voice-selection-modal__details-value">
            {originalName}
          </span>
        </div>

        {metaItems.map(item => (
          <div className="voice-selection-modal__details-row" key={item.label}>
            <span className="voice-selection-modal__details-key">
              {item.label}
            </span>
            <span className="voice-selection-modal__details-value">
              {item.value}
            </span>
          </div>
        ))}

        {variant === 'recommended' && typeof voice.rank === 'number' && (
          <div className="voice-selection-modal__details-row">
            <span className="voice-selection-modal__details-key">Rank</span>
            <span className="voice-selection-modal__details-value">
              {voice.rank}
            </span>
          </div>
        )}
      </div>

      {!!description && (
        <div className="voice-selection-modal__details-description">
          {description}
        </div>
      )}
    </Modal>
  )
}

export default VoiceDetailsModal
